import { render, staticRenderFns } from "./homeExpert.vue?vue&type=template&id=7ec0f221&scoped=true&"
import script from "./homeExpert.vue?vue&type=script&lang=js&"
export * from "./homeExpert.vue?vue&type=script&lang=js&"
import style0 from "./homeExpert.vue?vue&type=style&index=0&id=7ec0f221&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec0f221",
  null
  
)

export default component.exports